import React, {Fragment} from 'react'

import colorList from '../../../resources/data/colorList'

const CatalogueFilterLinkColor = ({title}) => {
  const style = {background: colorList[title]};

  return (
    <Fragment>
      <div className="color" style={style}/>
      <span className="color-name">{title}</span>
    </Fragment>
  )
};

export default CatalogueFilterLinkColor
